/* eslint-disable import/order */
import { formSubmitPageEntrypoint } from '@jira/router-routes__business-form-entries/src/ui/form-submit-public/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { softwareFormSubmitPublicRoute } from '@jira/router-routes__software-form-submit-public-routes/src/softwareFormSubmitPublicRoute.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareFormSubmitPublicRouteEntry: Route = createEntry(
	softwareFormSubmitPublicRoute,
	() => ({
		group: 'software',
		ufoName: 'next-gen-form-submit-public',
		layout: chromelessLayout,
		resources: [...jiraSpaResources()],

		// This public route should not include
		// DEPRECATED_DO_NOT_USE_projectDetailsResource as a resource, unless we
		// remove all usages of projectKey.
		entryPoint: () => formSubmitPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
